export default __webpack_public_path__ + "static/media/hydrationstation2.1bde3201.png";